var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereumLogoRound(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.123 7v9.609l8.122 3.629L20.123 7z",
    fill: "#fff",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.123 7L12 20.238l8.123-3.63V7z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.123 26.465v6.529L28.25 21.75l-8.127 4.715z",
    fill: "#fff",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.123 32.994v-6.53L12 21.75l8.123 11.244z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.123 24.954l8.122-4.716-8.122-3.627v8.343z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.238l8.123 4.716V16.61L12 20.238z",
    fill: "#fff",
    fillOpacity: 0.602
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogoRound);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDQwQzMxLjA0NTcgNDAgNDAgMzEuMDQ1NyA0MCAyMEM0MCA4Ljk1NDMgMzEuMDQ1NyAwIDIwIDBDOC45NTQzIDAgMCA4Ljk1NDMgMCAyMEMwIDMxLjA0NTcgOC45NTQzIDQwIDIwIDQwWiIgZmlsbD0iIzYyN0VFQSIvPgo8cGF0aCBkPSJNMjAuMTIzNSA3VjE2LjYwODlMMjguMjQ1IDIwLjIzNzlMMjAuMTIzNSA3WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC42MDIiLz4KPHBhdGggZD0iTTIwLjEyMjggN0wxMi4wMDAyIDIwLjIzNzlMMjAuMTIyOCAxNi42MDg5VjdaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjAuMTIzNSAyNi40NjQ4VjMyLjk5MzhMMjguMjUwNCAyMS43NTAyTDIwLjEyMzUgMjYuNDY0OFoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNjAyIi8+CjxwYXRoIGQ9Ik0yMC4xMjMxIDMyLjk5MzhWMjYuNDYzN0wxMi4wMDA1IDIxLjc1MDJMMjAuMTIzMSAzMi45OTM4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIwLjEyMzUgMjQuOTUzNkwyOC4yNDUgMjAuMjM4TDIwLjEyMzUgMTYuNjExMVYyNC45NTM2WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0xMi4wMDA1IDIwLjIzOEwyMC4xMjMxIDI0Ljk1MzZWMTYuNjExMUwxMi4wMDA1IDIwLjIzOFoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNjAyIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };